import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OccOrderService, OrderActions } from '@order/data-access';
import { normalizeHttpError, Order } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class OnlineOrderDetailsEffect {
  onlineOrderDetailsLoad$: Observable<OrderActions.OnlineOrderDetailsActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderActions.ONLINE_ORDER_DETAILS_LOAD),
      map((action: OrderActions.OnlineOrderDetailsLoad) => action.payload),
      switchMap((payload) => {
        return this.occOrderService.loadOnlineOrderDetails(payload.orderCode).pipe(
          map((order: Order) => new OrderActions.OnlineOrderDetailsLoadSuccess(order)),
          catchError((error) => of(new OrderActions.OnlineOrderDetailsLoadFail(normalizeHttpError(error)))),
        );
      }),
    ),
  );

  offlineOrderDetailsLoad$: Observable<OrderActions.OnlineOrderDetailsActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderActions.OFFLINE_ORDER_DETAILS_LOAD),
      map((action: OrderActions.OfflineOrderDetailsLoad) => action.payload),
      switchMap((payload) => {
        return this.occOrderService.loadOfflineOrderDetails(payload.orderCode).pipe(
          map((order) => new OrderActions.OnlineOrderDetailsLoadSuccess(order)),
          catchError((error) => of(new OrderActions.OnlineOrderDetailsLoadFail(normalizeHttpError(error)))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private occOrderService: OccOrderService,
  ) {}
}
